/*eslint-disable*/
import { GET_TOASTS } from "../actionTypes";

const initialState: ToastState = {
  toasts_list: [],
};

export const ToastReducer = (
  state: ToastState = initialState,
  action: ToastActions
) => {
  switch (action.type) {
    case GET_TOASTS:
      return {
        ...state,
        toasts_list: action.payload,
      };
    default:
      return state;
  }
};
